export default __webpack_public_path__ + "images/35ad71d68b6a7813a666aeeb0a70e4d3.png";